import React, { Component } from 'react';
import moment from 'moment';

import { defaultSorter, dateSorter } from './Helpers';
import UserModel from './UserModel'

import { Table, Tooltip, Row, Col, Statistic } from 'antd';

class UrbioticaMessagesTable extends Component {

  state = {
    filteredInfo: null,
    children: []
  }
  handleChange = (pagination, filters, sorter) => {
    this.setState({
      filteredInfo: filters
    });
  };

  expandedRowRender(record) {
    return (
      <div>
        <Row style={{ marginBottom: 20 }}>
          <Col span={3}>
            <Statistic
              formatter={(value) => { return value; }}
              title="Latitude"
              value={record.latitude} />
          </Col>
          <Col span={3}>
            <Statistic
              formatter={(value) => { return value; }}
              title="Longitude"
              value={record.longitude} />
          </Col>
          <Col span={3}>
            <Statistic
              formatter={(value) => { return value; }}
              title="ProjectID"
              value={record.projectID} />
          </Col>
          <Col span={3}>
            <Statistic
              formatter={(value) => { return value; }}
              title="OrganismID"
              value={record.organismID} />
          </Col>
          <Col span={2}>
            <Statistic
              formatter={(value) => { return value; }}
              title="Unit"
              value={record.unit} />
          </Col>
          <Col span={4}>
            <Statistic
              formatter={(value) => { return value; }}
              title="lStamps"
              value={record.lstamps} />
          </Col>
          <Col span={2}>
            <Statistic
              formatter={(value) => { return value; }}
              title="PomDesc"
              value={record.pomdesc} />
          </Col>
          <Col span={1}>
            <Statistic
              formatter={(value) => { return value; }}
              title="ZoneID"
              value={record.zoneID} />
          </Col>
        </Row>
        <Row>
          <Col span={3}>
            <Statistic
              formatter={(value) => { return value; }}
              title="AssetID"
              value={record.assetID} />
          </Col>
          <Col span={4}>
            <Statistic
              formatter={(value) => { return value; }}
              title="TZ"
              value={record.tz} />
          </Col>
          <Col span={3}>
            <Statistic
              formatter={(value) => { return value; }}
              title="ProductType"
              value={record.productType} />
          </Col>
          <Col span={2}>
            <Statistic
              formatter={(value) => { return value; }}
              title="Tags"
              value={record.tags} />
          </Col>
        </Row>
      </div >
    );
  }

  render() {
    let { filteredInfo } = this.state;
    filteredInfo = filteredInfo || {};
    let poms = [];
    this.props.data.forEach(element => {
      if ((element.pom) && poms.indexOf(element.pom) === -1) {
        poms.push(element.pom);
      }
    });
    poms.sort();
    let pomFilter = [];
    poms.forEach(pom => {
      pomFilter.push({ text: pom, value: pom });
    });
    return (
      <Table
        size='small'
        rowKey={this.props.rowKey ? this.props.rowKey : 'id'}
        loading={this.props.loading ? this.props.loading : false}
        columns={[
          {
            title: 'POM',
            dataIndex: 'pom',
            key: 'pom',
            width: 30,
            filters: pomFilter,
            filteredValue: filteredInfo.pom || null,
            onFilter: (value, record) => record.pom === value,
            ellipsis: true
          }, {
            title: 'ElementID',
            dataIndex: 'elementID',
            key: 'elementID',
            width: 30,
          }, {
            title: 'Typ zprávy',
            dataIndex: 'phenomenonID',
            key: 'phenomenonID',
            width: 50,
            filters: [{
              text: 'vehicle_ctrl',
              value: 'vehicle_ctrl',
            }, {
              text: 'vehicle',
              value: 'vehicle',
            }],
            onFilter: (value, record) => record.phenomenonID === value,
          }, {
            title: 'Occ',
            dataIndex: 'measures',
            key: 'measures',
            width: 50,
          }, {
            title: 'Časová značka',
            dataIndex: 'stamps',
            key: 'stamps',
            width: 200,
            defaultSortOrder: 'descend',
            sorter: (a, b) => dateSorter(a.stamps, b.stamps),
            render: (text, record) => {
              return moment(text).format('L LTS');
            }
          }
        ]}
        dataSource={this.props.data}
        onChange={this.handleChange}
        expandedRowRender={this.expandedRowRender.bind(this)}
        style={{ border: '0px' }}
        pagination={{
          showSizeChanger: true,
          defaultPageSize: localStorage.getItem('table_pageSize') !== undefined
            ? parseInt(localStorage.getItem('table_pageSize'))
            : 10,
          onShowSizeChange: (current, size) => {
            localStorage.setItem('table_pageSize', size);
          }
        }}
      />
    );
  }
}

export default UrbioticaMessagesTable;


// WEBPACK FOOTER //
// ./src/components/UrbioticaMessagesTable.js